import React, {Component} from 'react';
import Loader from "react-loader-spinner";

export default class Roles extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userRoleDetails: []
           }
            }

    render() {
        const loader = {
            height: '700px',
            left: '40%',
            position: 'relative',
        };

        console.log("=== LOG_3 === Inside %s with data","Roles",this.props.data.data);

        if (!this.props.data.data || this.props.data.data.loading) {
            return <Loader style={loader} type="ThreeDots" color="#e9953c" radius="5px" timeout={10000}/>;
        }

        const rolesList = this.props.data.data.userRoleDetails.map((i) => {
                return <option value={i.roleID}>{i.roleName}</option>;
        });
        return <div className="tab-pane" id="tb_roles" role="tabpanel">
            <div className="row">
                <div className="col-md-6">
                    <h5 className="tbsub-title mt-3 mb-3">Roles</h5>
                    <div className="form-group">
                        <label className="control-label">Select User</label>
                        <select className="form-control select2">
                            {rolesList}
                        </select>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-9">
                    <h5 className="tbsub-title mt-3 mb-3">Permissions</h5>
                    <div className="tbl_permissions_outer">
                        <table className="table">
                            <thead>
                            <tr>
                                <th>Permission Name</th>
                                <th>Permission Description</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td>Alertplus-Configure Terminal</td>
                                <td>Allow access to Alertplus Settings</td>
                            </tr>
                            <tr>
                                <td>Create_User</td>
                                <td>Permission to create new Users</td>
                            </tr>
                            <tr>
                                <td>Delete Message</td>
                                <td>Permission to Delete Message</td>
                            </tr>
                            <tr>
                                <td>Alertplus-Configure Terminal</td>
                                <td>Allow access to Alertplus Settings</td>
                            </tr>
                            <tr>
                                <td>Create_User</td>
                                <td>Permission to create new Users</td>
                            </tr>
                            <tr>
                                <td>Delete Message</td>
                                <td>Permission to Delete Message</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    }
}